import type { SVGProps } from "react";
export interface EyeAltOffIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function EyeAltOffIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: EyeAltOffIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="m12.809 5.917.391.05c3.96.61 5.764 4.094 6.25 5.204l.077.202c.13.41.13.845 0 1.254l-.076.202a10 10 0 0 1-.138.297l-.054.101a1.125 1.125 0 0 1-1.974-1.075l.07-.15c-.476-1.054-1.837-3.4-4.507-3.814l-.268-.033-.114-.018a1.126 1.126 0 0 1 .229-2.226zM19.875 8V6c0-1.035-.84-1.875-1.875-1.875h-2a1.126 1.126 0 0 1 0-2.25h2A4.125 4.125 0 0 1 22.125 6v2a1.125 1.125 0 0 1-2.25 0m-18 10v-2a1.125 1.125 0 0 1 2.25 0v2c0 1.036.84 1.875 1.875 1.875h2l.116.006a1.125 1.125 0 0 1 0 2.239L8 22.125H6A4.125 4.125 0 0 1 1.875 18m6.292-8.242a7.9 7.9 0 0 0-1.523 2.241c.524 1.164 2.111 3.876 5.355 3.876.73 0 1.367-.138 1.926-.357l-.662-.663c-.386.172-.813.27-1.262.27a3.126 3.126 0 0 1-2.858-4.392zM1.875 8V6c0-.729.191-1.415.523-2.01L1.205 2.796l-.078-.085A1.125 1.125 0 0 1 2.71 1.127l.085.078 20 20 .078.086a1.124 1.124 0 0 1-1.582 1.582l-.087-.078L20.01 21.6a4.1 4.1 0 0 1-2.009.525h-2a1.126 1.126 0 0 1 0-2.25h2c.09 0 .177-.01.263-.021l-2.65-2.649a7.4 7.4 0 0 1-3.614.92c-4.198 0-6.349-3.13-7.175-4.723l-.275-.574a2.06 2.06 0 0 1 0-1.657l.157-.338a10.1 10.1 0 0 1 1.87-2.666l-2.431-2.43a2 2 0 0 0-.02.263v2a1.125 1.125 0 0 1-2.25 0Z"
      />
    </svg>
  );
}
